import { useContext } from 'react';

import { FilesContext } from '../context/FilesProvider';

export const useFilesContext = () => {
  const context = useContext(FilesContext);

  if (!context) {
    throw new Error('useFilesContext must be used within an FilesProvider');
  }

  return context;
};
